import { ref, watch, onMounted } from "@vue/composition-api";
import { IPadProConfigs, DefaultConfigs } from "../../services/DefaultConfigs";

export default function useBoxplotChartOutliers(dataRef, configRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef, isIPadProRef) {
  const outliers = ref([]);

  const updateOutliers = () => {
    const dataOutliers = dataRef?.value?.outliers;

    if (!dataOutliers || !xRef?.value || !yRef?.value) {
      outliers.value = [];
      return;
    }

    const halfXBandwidth = xBandwidthRef.value / 2;
    const outlierShift = DefaultConfigs.BoxplotChart.outlierShift;
    const radius = isIPadProRef?.value ? IPadProConfigs.BoxplotChart.outlierRadius : DefaultConfigs.BoxplotChart.outlierRadius;
    const strokeWidth = DefaultConfigs.BoxplotChart.outlierStrokeWidth;

    const newOutliers = [];
    for (const outlier of dataOutliers) {
      const groupedValues = new Map();
      const { stroke: strokeColor } = outlier.colors;

      for (const value of outlier.values) {
        groupedValues.set(value, ( groupedValues.get(value) ?? 0) + 1);
      }

      for (let [ value, count ] of groupedValues.entries()) {
        const groupLeftShift = ((count - 1) * outlierShift / 2);

        let x = xRef.value(outlier.x) + halfXBandwidth - groupLeftShift;
        const y = yRef.value(value);

        while (count-- > 0) {
          newOutliers.push({ x, y, radius, strokeColor, strokeWidth });

          x += outlierShift;
        }
      }
    }

    outliers.value = newOutliers;
  };

  watch([dataRef, configRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef, isIPadProRef], updateOutliers);

  onMounted(updateOutliers);

  return { outliers };
}
